<template>
  <modal @close="clearField" width="22.4rem" height="auto" minHeight="auto">
    <div class="success-send-request py-12 px-9 text-center" slot="body">
      <img src="/dist/assets/front_white/img/icons/check-round.svg" alt="success" class="mb-6">
      <h4 class="h4 active-color mb-6">Заявка отправлена</h4>
      <p class="mb-11">
        <span class="fw-bold">Спасибо за заявку!</span> Мы с вами свяжемся.
      </p>

      <!-- //TODO: сделать обработчик закрытия модалки -->
      <v-btn color="green" @click="$emit('close')" big class="mx-auto">Принять</v-btn>
    </div>
  </modal>
</template>

<script>
import modal from "../Modal.vue";
export default {
  components: { modal },
  methods: {
    // ф-ия очистки
    clearField() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
@import "./src/front_white/sass/components/color";
</style>
